import { SelectionWrapper } from "widgets/configurator/door-options-controls/SelectionWrapper";
import { DoorColorChoice } from "./DoorColorChoice";
import { useColorHelper } from "../helpers/useColorHelper";

const ColorOptionControls = () => {
  const {
    doorOptionsLoading,
    doorOptionsLoadError,
    colorsContainer,
    selectedColor,
    onColorClick,
  } = useColorHelper();

  if (doorOptionsLoading) {
    return <div>Loading...</div>;
  } else if (doorOptionsLoadError) {
    return <div>Error!</div>;
  }

  return (
    <div className="gg-mt-3 gg-grid gg-w-full gg-gap-y-4">
      <div className="gg-w-full gg-max-w-fit">
        <SelectionWrapper>
          {colorsContainer.map((color, index) => {
            const isActive = selectedColor?.code === color.code;
            return (
              <DoorColorChoice
                key={color.code}
                selectColor={onColorClick}
                color={color}
                isActive={isActive}
              />
            );
          })}
        </SelectionWrapper>
      </div>
    </div>
  );
};
export default ColorOptionControls;
